import React from 'react';
import {NavLink} from "react-router-dom";
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import PropTypes from 'prop-types';
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import moment from 'moment';
import { Map, Marker, LayersControl, TileLayer } from 'react-leaflet'

import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import withStyles from '@material-ui/core/styles/withStyles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import AppBar from '@material-ui/core/AppBar';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import LocationSearchInput from '../utils/LocationSearchInput'
import ImgMediaCard from '../utils/ImgMediaCard'
import SearchSelect from '../utils/SearchSelect'
import Picker from '../utils/Picker'
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import 'moment/locale/fr';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import CheckboxList from '../utils/CheckboxList'

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
moment.locale('fr');

const { BaseLayer } = LayersControl

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
    height: 40
  },
  back: {
    marginTop: theme.spacing.unit * 3,
    marginRight: 20,
    height: 40
  },
  button: {
    marginTop: theme.spacing.unit * 3,
  },
  input: {
    display: 'none',
  },
  media: {
    // ⚠️ object-fit is not supported by IE11.
    objectFit: 'cover',
  },
  marginDivier: {
    marginTop: theme.spacing.unit * 3,
  },
  tabContainer: {
    margin: 0,
    padding: 0
  },
  typoMargin : {
    marginBottom: 20
  },
  prev: {
    position: 'absolute',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 12,
    zIndex: 9,
  },
  next: {
    position: 'absolute',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 4,
    zIndex: 9,
  },
  textarea: {
    width: "100%",
    height: "100%",
    minHeight: 300,
  }
});

function TabContainer(props) {
  return (
    <Typography component="div" >
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

class EditAudit extends React.Component {

  render() {
    return (
      <React.Fragment>
        <CssBaseline />

          <NavLink to={"/audits/"} style={{ textDecoration: 'none' }}>
            <Button variant="outlined" size="large" >Retour</Button>
          </NavLink>
          <Grid container spacing={24}>

            <Grid item xs={12} md={6} lg={8}>
              <Paper className={this.props.classes.paper} elevation={2}>
                <Tabs
                  value={this.props.tabValue}
                  onChange={this.props.handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  fullWidth
                >
                  <Tab label="Photo" />
                  <Tab label="Carte" />
                </Tabs>
                <SwipeableViews
                  axis="x"
                  index={this.props.tabValue}
                  onChangeIndex={this.props.handleTabChangeIndex}
                >
                  <TabContainer dir="x">
                    {(this.props.formData.preview && Object.keys(this.props.formData.preview).length > 0) &&
                      <Card >
<CardMedia
  component="img"
  className={this.props.classes.media}
  height="400"
  image={this.props.formData.preview.path}
  title="Lieu de l'audit"
/>
                      </Card>}
                  </TabContainer>
                  <TabContainer dir="x">
                    {(this.props.audit && Object.keys(this.props.audit).length > 0) &&
                      <Map center={[this.props.audit.latitude, this.props.audit.longitude]} zoom={18}>
                        <LayersControl position="topright">
<BaseLayer checked name="Normal">
  <TileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      attribution="&copy; <a href=&quot;https://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
  />
</BaseLayer>
<BaseLayer name="Noir & Blanc">
  <TileLayer
    attribution="&amp;copy <a href=&quot;https://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
    url="https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png"
  />
</BaseLayer>
<Marker position={[this.props.audit.latitude, this.props.audit.longitude]}/>
                        </LayersControl>
                      </Map>
                    }
                  </TabContainer>
                </SwipeableViews>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <Paper className={this.props.classes.paper} elevation={2}>
                <Typography variant="headline" component="h3">Mes notes</Typography>
                <CheckboxList notes={this.props.formData.notes} handleInputChange={this.props.handleInputChange} />
              </Paper>
            </Grid>

          </Grid>



          {(this.props.prevAudit) && (
              <NavLink to={"/audits/" + this.props.prevAudit.id} style={{ textDecoration: 'none' }}>
                <Button variant="fab" className={this.props.classes.prev} color='primary'>
                  {"<"}
                </Button>
              </NavLink>
          )}
          {(this.props.nextAudit) && (
              <NavLink to={"/audits/" + this.props.nextAudit.id} style={{ textDecoration: 'none' }}>
                <Button variant="fab" className={this.props.classes.next} color='primary'>
                  {">"}
                </Button>
              </NavLink>
          )}

            <MuiPickersUtilsProvider locale="fr" moment={moment} utils={MomentUtils}>
              <ValidatorForm onSubmit={this.props.handleFormSubmit} className={this.props.classes.form}>

                <Grid container spacing={24}>

                  <Grid item xs={12} md={8}>
                    <Paper className={this.props.classes.paper} elevation={2}>
                      <Typography variant="headline" component="h3">Informations</Typography>
                      <Grid container spacing={24}>
                      <Grid item xs={12} sm={4} >
<FormControl margin="normal" required fullWidth>
    <TextValidator
        label="Nom du client (ex : M. Doe)"
        onChange={this.props.handleInputChange}
        name="client"
        value={this.props.formData.client}
        validators={['required']}
        errorMessages={['ce champ est requis']}
    />
</FormControl>
                      </Grid>
                        <Grid item xs={12} sm={8} >
<LocationSearchInput address={this.props.formData.address} handleInputChange={this.props.handleInputChange} />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
<FormControl margin="normal" fullWidth>
  <Picker
    label="Date du rendez-vous"
    onChange={this.props.handleDateChange("date")}
    name="date"
    value={this.props.formData.date}
    format="DD/MM/YYYY HH:mm"
  />
  {!this.props.user.google_access_token_expire_at && (
      <div>
        <Typography variant="subheading" color="secondary">La synchronisation "Google Agenda" est désactivé !</Typography>
        <NavLink to={"/account/"} >Activer la synchronisation</NavLink>
      </div>
  )}
</FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
<FormControl margin="normal" fullWidth>
    <Picker
      dateOnly
      label="Date limite"
      onChange={this.props.handleDateChange("dateLimit")}
      name="dateLimit"
      value={this.props.formData.dateLimit}
      format="DD/MM/YYYY"
    />
</FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
<FormControl margin="normal" required fullWidth>
    <TextValidator
        label="Lot n°"
        onChange={this.props.handleInputChange}
        name="lot"
        value={this.props.formData.lot}
    />
</FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
<FormControl margin="normal" required fullWidth>
  <InputLabel htmlFor="type">Type</InputLabel>
  <Select
    name="type"
    value={this.props.formData.type ? this.props.formData.type : ""}
    onChange={this.props.handleInputChange}
    inputProps={{
      name: 'type',
      id:'type'
    }}
  >
    {this.props.listOfAuditTypes.map(auditType => (
      <MenuItem key={auditType.name} value={auditType.id}>
        {auditType.name}
      </MenuItem>
    ))}
  </Select>
</FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
<FormControl margin="normal" required fullWidth>
    <TextValidator
        label="Référence de l'audit"
        onChange={this.props.handleInputChange}
        name="reference"
        value={this.props.formData.reference}
        validators={['required']}
        errorMessages={['ce champ est requis']}
    />
</FormControl>
                        </Grid>
                      </Grid>

                      <Grid container spacing={24}>
                        <Grid item xs={12} md={12} lg={6} >
<FormControl margin="normal" required fullWidth>
  <SearchSelect name="qualifications" label="Qualification(s)" placeholder="Liste des qualification(s)" defaultValue={this.props.formData.qualifications} options={this.props.listOfQualifications.filter(x => x.speciality.activity.family.audit_type.id === this.props.formData.type)} handleInputChange={this.props.handleInputChange} />
</FormControl>
                        </Grid>
                        <Grid item xs={12} md={12} lg={6} >
<FormControl margin="normal" required fullWidth>
  <SearchSelect name="mentions" label="Mention(s)" placeholder="Liste des mention(s)" defaultValue={this.props.formData.mentions} options={this.props.listOfMentions.filter(x => x.audit_type.id === this.props.formData.type)} handleInputChange={this.props.handleInputChange} />
</FormControl>
                        </Grid>
                      </Grid>

                      <Grid container spacing={24}>
                        <Grid item md={12} lg={4}>
<Typography variant="button" >Plan d'audit</Typography>
<FormControl margin="normal" required fullWidth>
  <input
    accept="image/*"
    className={this.props.classes.input}
    onChange={this.props.handleFileChange}
    id="summary"
    name="summary"
    type="file"
  />
  <label htmlFor="summary">
    <Button variant="contained" component="span" >
      {(this.props.formData.summary && Object.keys(this.props.formData.summary).length > 0) ? "Remplacer" : "Envoyer"}
    </Button>
  </label>
  {(this.props.formData.summary && Object.keys(this.props.formData.summary).length > 0) &&
    <ImgMediaCard
      title="Plan d'audit"
      image={this.props.formData.summary.path}
      onDelete={this.props.displayConfirmation}
      deleteCallback={() => this.props.handleFileRemove("summary")}
    />}
</FormControl>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Grid container spacing={24}>

                      <Grid item xs={12}>
                        <Paper className={this.props.classes.paper} elevation={2}>
<Typography variant="headline" component="h3">Entreprise audité</Typography>

<Grid container spacing={24}>
  <Grid item xs={12} lg={6}>
    <FormControl margin="normal" required fullWidth>
        <TextValidator
            label="Raison sociale"
            onChange={(e) => this.props.handleInputChange(e, 'company')}
            name="name"
            value={this.props.formData.company.name}
            validators={['required']}
            errorMessages={['ce champ est requis']}
        />
    </FormControl>
  </Grid>
  <Grid item xs={12} lg={6}>
    <FormControl margin="normal" required fullWidth>
        <TextValidator
            label="Référence de l'entreprise"
            onChange={(e) => this.props.handleInputChange(e, 'company')}
            name="reference_company"
            value={this.props.formData.company.reference}
            validators={['required']}
            errorMessages={['ce champ est requis']}
        />
    </FormControl>
  </Grid>
  <Grid item xs={12} lg={6}>
    <FormControl margin="normal" required fullWidth>
        <TextValidator
            label="Nom du responsable"
            onChange={(e) => this.props.handleInputChange(e, 'company')}
            name="manager"
            value={this.props.formData.company.manager}
            validators={['required']}
            errorMessages={['ce champ est requis']}
        />
    </FormControl>
  </Grid>
  <Grid item xs={12} lg={6}>
    <FormControl margin="normal" required fullWidth>
        <TextValidator
            label="Téléphone"
            onChange={(e) => this.props.handleInputChange(e, 'company')}
            name="phone"
            value={this.props.formData.company.phone}
            validators={['required', 'matchRegexp:^[ 0-9]*$']}
            errorMessages={['ce champ est requis', 'La valeur du champ est invalide']}
        />
    </FormControl>
  </Grid>
  <Grid item xs={12} lg={6}>
    <FormControl margin="normal" required fullWidth>
        <TextValidator
            label="Email"
            onChange={(e) => this.props.handleInputChange(e, 'company')}
            name="email"
            value={this.props.formData.company.email}
            validators={['required', 'isEmail']}
            errorMessages={['ce champ est requis', 'email is not valid']}
        />
    </FormControl>
  </Grid>
  <Grid item xs={12} lg={6}>
    <FormControl margin="normal" required fullWidth>
        <TextValidator
            label="Siret"
            onChange={(e) => this.props.handleInputChange(e, 'company')}
            name="siret"
            value={this.props.formData.company.siret}
            validators={['required', 'matchRegexp:^[0-9]{3}[ .-]?[0-9]{3}[ .-]?[0-9]{3}[ .-]?[0-9]{5}$']}
            errorMessages={['ce champ est requis', 'Le siret doit être au format 123 456 789 12345']}
        />
    </FormControl>
  </Grid>
  <Grid item xs={12} lg={6}>
    <FormControl margin="normal" required fullWidth>
        <TextValidator
            label="Département (ex : 75)"
            onChange={(e) => this.props.handleInputChange(e, 'company')}
            name="department"
            value={this.props.formData.company.department}
            validators={['required', 'matchRegexp:^[0-9]*$']}
            errorMessages={['ce champ est requis', 'Numéro de département invalide']}
        />
    </FormControl>
  </Grid>

</Grid>
                        </Paper>
                      </Grid>

                      <Grid item xs={12}>
                        <Paper className={this.props.classes.paper} elevation={2}>
<Typography variant="headline" component="h3">Status</Typography>
  <Grid container spacing={24}>

      <Grid item xs={12}>
        <FormControl margin="normal" required >
          <InputLabel htmlFor="type">État</InputLabel>
          <Select
            name="status"
            value={this.props.formData.status ? this.props.formData.status : ""}
            onChange={this.props.handleInputChange}
            inputProps={{
              name: 'status',
              id:'status'
            }}
          >
          <MenuItem key="0" value="waiting">
            En attente
          </MenuItem>
          <MenuItem key="1" value="appointment_notified">
            Rendez-vous proposé
          </MenuItem>
          <MenuItem key="2" value="appointment">
            Rendez-vous confirmé
          </MenuItem>
          <MenuItem key="3" value="valid">
            Validé
          </MenuItem>
          <MenuItem key="4" value="issue">
            Écart
          </MenuItem>
          <MenuItem key="5" value="reject">
              Rejeté
          </MenuItem>
          <MenuItem key="6" value="issue_invoiced">
              Écart à facturer
          </MenuItem>
          </Select>
        </FormControl>
    </Grid>

      {(this.props.audit.report) &&
      (
        <Grid item xs={12}>

              <NavLink
                  to={"/reports/" + this.props.audit.report.id}
                  style={{ textDecoration: 'none' }}
              >
                <Button variant="outlined" size="large" >
                  {
                    "Voir le rapport"
                  }
                </Button>
              </NavLink>
        </Grid>
      )
      }
      {(this.props.formData.status === "valid" || this.props.formData.status === "reject" || this.props.formData.status === "issue_invoiced") &&
      (
        <Grid item xs={12}>

                <NavLink
                    to={(this.props.audit.invoices.length > 0) ? ("/invoices/" + this.props.audit.invoices[0].id) : ("/invoices/new")}
                    style={{ textDecoration: 'none' }}
                >
                    <Button variant="outlined" >
                        {
  (this.props.audit.invoices.length > 0) ? "Voir la facture" : "Créer une facture"
                        }
                    </Button>
                </NavLink>
        </Grid>
      )
      }

</Grid>
                        </Paper>
                      </Grid>

                    </Grid>
                  </Grid>
                </Grid>
                <Grid container spacing={24}>

                  <Grid item xs={12}>
                    <Button
type="submit"
variant="raised"
color="primary"
className={this.props.classes.submit}
disabled={this.props.submitted}
style={{marginRight: 20}}
                      >
                        {
  (this.props.submitted && "Enregistrement en cours...") ||
  (!this.props.submitted && "Enregister")
                        }
                    </Button>
                      <Button variant="outlined" color="default" className={this.props.classes.submit} onClick={this.props.handleClickOpenDialog}>
Modèles d'email
                      </Button>
                  </Grid>


                </Grid>
              </ValidatorForm>
            </MuiPickersUtilsProvider>

        <Dialog
            onClose={this.props.handleClickCloseDialog}
            aria-labelledby="customized-dialog-title"
            open={this.props.openDialog}
        >
          <DialogContent style={{padding: 0}}>
            <AppBar position="static" color="default">
              <Tabs
                  value={this.props.emailsValue}
                  onChange={this.props.handleChangeEmails}
                  indicatorColor="primary"
                  textColor="primary"
                  fullWidth
              >
                <Tab label="Prise de RDV" />
                <Tab label="Confirmation" />
                <Tab label="Relance" />
              </Tabs>
            </AppBar>
            <SwipeableViews
                axis={'x'}
                index={this.props.emailsValue}
                onChangeIndex={this.props.handleChangeEmailsIndex}
            >
              <TabContainer dir={'ltr'}>
                <Grid container spacing={24}>
                  <Grid item xs={12} style={{padding:20}}>
                      <textarea className={this.props.classes.textarea} value={"Bonjour,\n" +
                      "\n" +
                      "Je me permets de vous adresser cet e-mail suite à notre discussion téléphonique.\n" +
                      "\n" +
                      "Je suis missionnée par Qualibat pour réaliser votre audit RGE et je vous propose de le faire le " + (('date' in this.props.audit && this.props.audit.date) ? moment(this.props.audit.date).format('DD/MM/YYYY à HH:mm') : "#DATE")  + " chez " + (('client' in this.props.audit && this.props.audit.client) ? this.props.audit.client : "#CLIENT") + " au " + (('address' in this.props.audit && this.props.audit.address) ? this.props.audit.address : "#ADRESSE") + ".\n" +
                      "\n" +
                      "Si cela vous convient ainsi que votre client, je vous prie de me le confirmer au plus vite possible afin que je puisse étudier votre dossier.\n" +
                      "\n" +
                      "Merci par avance.\n" +
                      "\n" +
                      "Bien cordialement ;"} cols={40} rows={10} />
                  </Grid>
                </Grid>
              </TabContainer>
              <TabContainer dir={'ltr'}>
                <Grid container spacing={24}>
                  <Grid item xs={12} style={{padding:20}}>
                    <textarea className={this.props.classes.textarea} value={"Bonjour,\n" +
                    "\n" +
                    "Je me permets de vous adresser cet e-mail suite à notre conversation téléphonique pour vous confirmer notre rdv du " + (('date' in this.props.audit && this.props.audit.date) ? moment(this.props.audit.date).format('DD/MM/YYYY à HH:mm') :"#DATE" ) +" à l'adresse suivante : " + (('address' in this.props.audit && this.props.audit.address) ? this.props.audit.address :"#ADRESSE") +", afin de réaliser votre audit RGE.\n" +
                    "\n" +
                    "Pour cela vous devez être muni des documents suivants :\n\n" +
                    "* Le plan d'audit en pièce jointe, rempli, signé et tamponné. La signature doit être précédée de la mention manuscrite « Avec l’accord du maitre d’ouvrage » ;\n" +
                    "* Le devis et la facture ;\n" +
                    "* Le procès-verbal et l'attestation des travaux signé par le client ;\n" +
                    "* Les fiches techniques et les certificats des produits fournis ;\n" +
                    "* Les photos prises lors de la mise en œuvre (si existantes).\n\n" +
                    "Si vous avez un empêchement, je vous prie de le signaler au moins 24 heures avant le rdv.\n" +
                    "\n" +
                    "Je reste à votre disposition pour toute demande.\n" +
                    "\n" +
                    "Bien cordialement ;" } cols={40} rows={10} />
                  </Grid>
                </Grid>
              </TabContainer>
              <TabContainer dir={'ltr'}>
                <Grid container spacing={24}>
                  <Grid item xs={12} style={{padding:20}}>
                    <textarea className={this.props.classes.textarea} value={"Bonjour,\n" +
                    "\n" +
                    "Je me permets de vous adresser cet e-mail suite à la tentative de vous joindre par téléphone.\n" +
                    "\n" +
                    "Je suis missionnée par Qualibat pour réaliser votre audit RGE et je vous propose de le faire le " + (('date' in this.props.audit && this.props.audit.date) ? moment(this.props.audit.date).format('DD/MM/YYYY à HH:mm') : "#DATE")  + " chez " + (('client' in this.props.audit && this.props.audit.client) ? this.props.audit.client : "#CLIENT") + " au " + (('address' in this.props.audit && this.props.audit.address) ? this.props.audit.address : "#ADRESSE") + "\n" +
                    "\n" +
                    "Je vous prie de prendre contact avec moi au plus vite possible afin que nous puissions organiser le rdv.\n" +
                    "\n" +
                    "Bien cordialement ;" } cols={40} rows={10} />
                  </Grid>
                </Grid>
              </TabContainer>
            </SwipeableViews>

          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClickCloseDialog} color="primary">
              Fermer
            </Button>
          </DialogActions>
        </Dialog>

      </React.Fragment>
    );
  }
}

EditAudit.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EditAudit);



// WEBPACK FOOTER //
// ./src/component/audit/editAudit.js